module.exports = __webpack_public_path__ + "img/hebei.dd37c1ec.png";